import React from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { Page, Header, Content } from '@backstage/core-components';

const useStyles = makeStyles({
  logsContainer: {
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 80px)',
    borderRadius: '4px',
    color: '#1e1e1e', // Setting text color to black for better contrast
    padding: '10px',
    border: '1px solid #444',
  },
  logs: {
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    margin: 0,
  },
  logLine: {
    '&:nth-child(odd)': {
      backgroundColor: '#ffffff', // Setting odd line background color to white for better readability
    },
    '&:nth-child(even)': {
      backgroundColor: '#f0f0f0', // Setting even line background color to a lighter shade for contrast
    },
  },
});

const BuildLogsPage = () => {
  const classes = useStyles();
  const location = useLocation();
  const { jobName, buildLogs } = location.state || { jobName: 'Unknown Job', buildLogs: 'No logs available' };

  return (
    <Page>
      <Header title={`Build Logs for ${jobName}`} />
      <Content>
        <div className={classes.logsContainer}>
          <pre className={classes.logs}>
            {buildLogs.split('\n').map((line, index) => (
              <div key={index} className={classes.logLine}>
                {line}
              </div>
            ))}
          </pre>
        </div>
      </Content>
    </Page>
  );
};

export default BuildLogsPage;
